module.exports = __webpack_public_path__ + "img/img_03.c0c76ff4.jpg";